import i18n from '@/plugins/i18n';

const lambdaCharts = () => ({
  lineChartsOverviewPage: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.noOfFunctions'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_function_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.cpuTotalTime'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_cpu_total_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.timeInMs'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'avg',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.noOfExecutions'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_invocations',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.noOfErrors'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_errors',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.avgMemoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_memory_utilization',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.percentageUnit'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'avg',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.averageDuration'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_lambda_duration',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        y: i18n.global.t('aws.timeInMs'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'avg',
    },
  ],
  lineChartsSubscriptionPage: [
    {
      metricName: 'lambda_invocations',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.invocationsCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'lambda_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.noOfErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'lambda_concurrent_executions',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.concurrentExecutions'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'lambda_throttles',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.throttles'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'lambda_dead_letter_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.deadLetterErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'lambda_duration',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.durationMs'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.ms'),
      },
    },
    {
      metricName: 'lambda_iterator_age',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.iterationAge'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.timestamp'),
      },
    },
    {
      metricName: 'lambda_estimated_cost',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.function'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.estimatedCost'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.value'),
      },
    },
  ],
});

export default lambdaCharts;
